// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"b6881188","61":"b6881188","78":"49ad788b","120":"b6881188","2345":"b6881188","2818":"b6881188","4017":"b6881188","4656":"50940842","5284":"e9a7fb49","7036":"49ad788b","7830":"b6881188","8833":"b6881188"}[chunkId] + ".chunk.css";
};